import React, { useContext, useEffect } from "react";
import { PRODUCT_TYPE_MOVIE_REWARDS, PRODUCT_TYPE_VOUCHER_MANAGER } from "@config/config";
import useAccess from "@hooks/useAccess";
import useWhiteLabelConfig from "@hooks/useWhiteLabelConfig";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import { BookSessionContext } from "@context/BookSessionContext";
import LoginComponent from "@components/Form/LoginComponent";
import SignupComponent from "@components/Form/SignupComponent";
import Tabs from "@components/Tabs";
import Loader from "@components/Ui/Loader";
import "./style.scss";

const FastAuthModal = ({ uuid, totalPrice = 0 }) => {
    const { user, isLoggedIn, isReadytoCheckout } = useContext(AuthContext);
    const { productTypeId } = useContext(ApplicationContext);
    const { fetchReInitialiseEway, openStripeCheckout, seasonalPage, setProceedToCheckout } = useContext(BookSessionContext);
    const { isStripeEnabled } = useWhiteLabelConfig();

    const isVoucherManager = productTypeId === PRODUCT_TYPE_VOUCHER_MANAGER;
    const isSeasonalPage = productTypeId === PRODUCT_TYPE_MOVIE_REWARDS && seasonalPage === true;
    const { isFullyLoggedIn, isTempUser } = useAccess();

    useEffect(() => {
        if (isReadytoCheckout === true && isLoggedIn && isFullyLoggedIn) {
            if ((isVoucherManager || isSeasonalPage) && totalPrice > 0) {
                setProceedToCheckout(true);
                if (isStripeEnabled) {
                    openStripeCheckout(uuid);
                } else {
                    fetchReInitialiseEway(uuid);
                }
            }
        }

    }, [isReadytoCheckout, user?.account_type_id]);

    return (
        <>
            {(!isLoggedIn || isTempUser) && (
                <Tabs>
                    <div label="Login">
                        <LoginComponent />
                    </div>
                    <div label="Sign Up">
                        <SignupComponent />
                    </div>
                </Tabs>
            )}
            {isLoggedIn && isFullyLoggedIn && (
                <div className="checkout-card__wrapper">
                    <Loader isLoading={true} />
                </div>
            )}
        </>
    );
};

export default FastAuthModal;
